/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleremoveobjectsprompt4Inputs */

const en_refineexampleremoveobjectsprompt4 = /** @type {(inputs: Refineexampleremoveobjectsprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the distracting objects in the background`)
};

const de_refineexampleremoveobjectsprompt4 = /** @type {(inputs: Refineexampleremoveobjectsprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne die störenden Objekte im Hintergrund`)
};

/**
* | output |
* | --- |
* | "Remove the distracting objects in the background" |
*
* @param {Refineexampleremoveobjectsprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleremoveobjectsprompt4 = /** @type {((inputs?: Refineexampleremoveobjectsprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleremoveobjectsprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleremoveobjectsprompt4(inputs)
	return de_refineexampleremoveobjectsprompt4(inputs)
});
export { refineexampleremoveobjectsprompt4 as "refineExampleRemoveObjectsPrompt" }